import { OTA_STEP_NAME, OTA_STEP_STATUS, OtaStepStatus } from '../types';

export const STEP_STATUS_MAP: Record<
  OtaStepStatus,
  'wait' | 'process' | 'finish' | 'error'
> = {
  [OTA_STEP_STATUS.COMPLETED]: 'finish',
  [OTA_STEP_STATUS.IN_PROGRESS]: 'process',
  [OTA_STEP_STATUS.PENDING]: 'wait',
  [OTA_STEP_STATUS.FAILED]: 'error',
  [OTA_STEP_STATUS.UNSPECIFIED]: 'wait',
};

export const OTA_STEP_LABEL: Record<string, string> = {
  [OTA_STEP_NAME.START]: 'Start',
  [OTA_STEP_NAME.CORTEX]: 'Download CORTEX',
  [OTA_STEP_NAME.MINUS]: 'Download MINUS',
  [OTA_STEP_NAME.UPDATE]: 'Update firmware',
};
